import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminStore } from './adminStore';
import './admin.css';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const { login } = useAdminStore();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() && !password.trim()) return setError('Username and password are required');
    if (!username.trim()) return setError('Username is required');
    if (!password.trim()) return setError('Password is required');
    setError(''); setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || 'Login failed';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <div className="logo-icon">⚙️</div>
          <h1 style={{ fontSize: '2rem', marginBottom: 4 }}>Seoul Station</h1>
          <p style={{ fontSize: '0.85rem', opacity: 0.6 }}>Admin Panel — Store Management</p>
        </div>

        {error && <div className="admin-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label>Username</label>
            <input type="text" value={username} autoFocus onChange={e => setUsername(e.target.value)} placeholder="Username" />
          </div>
          <div className="admin-field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button className="admin-login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in to Admin'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
